import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MainNavigationService } from '../main-navigation.service';
import { NGXLogger } from 'ngx-logger';

export interface TeaItemListResolverData {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teaItem: any | null;
  errors: string[];
}

@Injectable({
  providedIn: 'root'
})
export class TeaItemListResolver implements Resolve<TeaItemListResolverData> {
  private mainNavigationService = inject(MainNavigationService);
  private logger = inject(NGXLogger);


  resolve(route: ActivatedRouteSnapshot): Observable<TeaItemListResolverData> {
    const teaItemSlug = route.params['tea-item-slug'];
    
    if (!teaItemSlug) {
      return of({
        teaItem: null,
        errors: ['Tea item slug not found in route']
      });
    }

    // Fetch tea item data
    return this.mainNavigationService.getTeaItem(teaItemSlug).pipe(
      map((teaItem) => {
        return {
          teaItem,
          errors: []
        };
      }),
      catchError(error => {
        this.logger.error('An error occurred while retrieving the tea item:', error);
        return of({
          teaItem: null,
          errors: ['An error occurred while retrieving the tea item.']
        });
      })
    );
  }
}
